import { Component, OnInit } from '@angular/core';
import {DynamicDialogRef} from 'primeng/api';
import {DynamicDialogConfig} from 'primeng/api';
import { MembershipService } from '../../services/membership.service';

@Component({
  selector: 'app-membersauditlog',
  templateUrl: './membersauditlog.component.html',
  styleUrls: ['./membersauditlog.component.css']
})
export class MembersauditlogComponent implements OnInit {
  membershipAuditData: any = [];
  membershipNbr: string;
  autitMembershipColumns:any= [];
  showloading:boolean = false;

  constructor(private membershipService: MembershipService, 
    public ref: DynamicDialogRef, public config: DynamicDialogConfig) {

      this.membershipNbr = this.config.data.membershipNbr;
     }

  ngOnInit() {
    this.autitMembershipColumns = [
      { field: 'updateDate', header: 'Date' },
      { field: 'updateTime', header: 'Time' },
      { field: 'commentText', header: 'Comments' }
   ];
    this.showloading = true;

   
    this.membershipAuditData = [];
    this.membershipService.getMemberAudits(this.membershipNbr).subscribe((res: any) => {  
      this.showloading = false;    
      if (res.code == "SUCCESS") {
        this.membershipAuditData = res.response;
      } 
    });
  }


  
}
